export const REQUEST_FAILED = 'REQUEST_FAILED'

export const DELETE_ERROR = 'DELETE_ERROR'
export const DELETE_LAST_ERROR = 'DELETE_LAST_ERROR'
export const DELETE_All_ERRORS = 'DELETE_All_ERRORS'